import type { LocaleMessageBundle } from '../../types'

export const productGroupMessages: LocaleMessageBundle = {
  vi: {
    'product.groupProduct.model': 'Nhóm sản phẩm',
    'product.groupProduct.title': 'Nhóm sản phẩm',
    'product.groupProduct.fields.code': 'Mã nhóm sản phẩm',
    'product.groupProduct.fields.name': 'Tên nhóm sản phẩm',
    'product.groupProduct.fields.description': 'Mô tả',
    'product.groupProduct.fields.status': 'Trạng thái',
    'product.groupProduct.status.active': 'Đang dùng',
    'product.groupProduct.status.inactive': 'Tạm ngưng',
    'product.groupProduct.actions.add': 'Thêm nhóm',
    'product.groupProduct.actions.create': 'Thêm nhóm sản phẩm',
    'product.groupProduct.actions.update': 'Cập nhật nhóm sản phẩm',
    'product.groupProduct.dialog.createSubtitle': 'Tạo nhóm mới để quản lý sản phẩm dễ dàng hơn',
    'product.groupProduct.dialog.updateSubtitle': 'Cập nhật thông tin nhóm sản phẩm',
    'product.groupProduct.placeholders.code': 'Nhập mã nhóm',
    'product.groupProduct.placeholders.name': 'Nhập tên nhóm',
    'product.groupProduct.placeholders.description': 'Nhập mô tả nhóm (không bắt buộc)',
    'product.groupProduct.help.statusTitle': 'Trạng thái nhóm sản phẩm là gì?',
    'product.groupProduct.help.statusDescription':
      'Chỉ những nhóm đang dùng mới hiển thị khi chọn nhóm trong sản phẩm.',
    'product.groupProduct.actions.submitCreate': 'Tạo mới',
    'product.groupProduct.actions.submitUpdate': 'Cập nhật',
    'product.groupProduct.actions.cancel': 'Đóng',
    'product.groupProduct.actions.delete': 'Xóa',
    'product.groupProduct.actions.deleteTitle': 'Xóa nhóm sản phẩm',
    'product.groupProduct.deleteConfirm': 'Bạn có chắc muốn xóa nhóm {name}?',
    'product.groupProduct.errors.saveFailed': 'Không thể lưu nhóm sản phẩm. Vui lòng thử lại.',
    'product.groupProduct.validation.requiredCodeAndName':
      'Vui lòng nhập mã nhóm và tên nhóm sản phẩm.',
  },
  en: {
    'product.groupProduct.model': 'Product group',
    'product.groupProduct.title': 'Product groups',
    'product.groupProduct.fields.code': 'Group code',
    'product.groupProduct.fields.name': 'Group name',
    'product.groupProduct.fields.description': 'Description',
    'product.groupProduct.fields.status': 'Status',
    'product.groupProduct.status.active': 'Active',
    'product.groupProduct.status.inactive': 'Inactive',
    'product.groupProduct.actions.add': 'Add group',
    'product.groupProduct.actions.create': 'Create product group',
    'product.groupProduct.actions.update': 'Update product group',
    'product.groupProduct.dialog.createSubtitle':
      'Create a new group to manage products more easily',
    'product.groupProduct.dialog.updateSubtitle': 'Update product group information',
    'product.groupProduct.placeholders.code': 'Enter group code',
    'product.groupProduct.placeholders.name': 'Enter group name',
    'product.groupProduct.placeholders.description': 'Enter group description (optional)',
    'product.groupProduct.help.statusTitle': 'What is product group status?',
    'product.groupProduct.help.statusDescription':
      'Only active groups are shown when selecting a group in products.',
    'product.groupProduct.actions.submitCreate': 'Create',
    'product.groupProduct.actions.submitUpdate': 'Update',
    'product.groupProduct.actions.cancel': 'Cancel',
    'product.groupProduct.actions.delete': 'Delete',
    'product.groupProduct.actions.deleteTitle': 'Delete product group',
    'product.groupProduct.deleteConfirm': 'Are you sure you want to delete group {name}?',
    'product.groupProduct.errors.saveFailed': 'Unable to save product group. Please try again.',
    'product.groupProduct.validation.requiredCodeAndName':
      'Please enter the group code and group name.',
  },
}
